var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "hover-indicator" },
    [
      _c("d3-vertical-line", {
        attrs: { width: _vm.width, height: _vm.height, x: _vm.x }
      }),
      _c("d3-dot", {
        attrs: {
          width: _vm.width,
          height: _vm.height,
          x: _vm.x,
          y: _vm.points[_vm.i]
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-52274abb", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52274abb","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/evaluation_graph/hover_indicator.vue
// module id = 594
// module chunks = 0